// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

// (-- api-linter: core::0215::foreign-type-reference=disabled
//     aip.dev/not-precedent: Required to enable monitoring support in version 2. --)

import type { Security } from "./security_pb";
import type { MonitoringOptions } from "../../monitoring/v2/monitoring_options_pb";
import { getNameParser } from "../../../../../runtime";
import type { DeploymentComposition } from "./deployment_composition_pb";
import type { KubernetesResourceSpec } from "./kubernetes_resource_spec_pb";
import type { KubernetesConfigShortcut } from "./config_pb";
import type { VpaResourceSpec } from "./vpa_resource_spec_pb";
import type { PodDisruptionBudgetSpec } from "./pdb_spec_pb";

/**
 * Represents a deployment of a model.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.Deployment
 */
export type Deployment = {
/**
 * Resource name.
 *
 * @generated from field: string name = 1;
 */
name?: string;
/**
 * Optional. Human-readable name.
 *
 * @generated from field: string display_name = 2;
 */
displayName?: string;
/**
 * Optional. Description of the deployment.
 *
 * @generated from field: string description = 3;
 */
description?: string;
/**
 * The etag of the deployment.
 *
 * @generated from field: string etag = 4;
 */
etag?: string;
/**
 * Creation timestamp.
 *
 * @generated from field: google.protobuf.Timestamp create_time = 5;
 */
createTime?: string;
/**
 * Update timestamp.
 *
 * @generated from field: google.protobuf.Timestamp update_time = 6;
 */
updateTime?: string;
/**
 * Output only. Name of an entity that created the Deployment.
 *
 * @generated from field: string creator = 7;
 */
creator?: string;
/**
 * Security options.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Security security = 11;
 */
security?: Security;
/**
 * Custom CORS configuration that overrides the global settings for this specific deployment.
 * This allows for granular control of cross-origin resource sharing policies at the deployment level.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Cors cors = 17;
 */
cors?: Cors;
/**
 * Monitor configuration for the deployment.
 *
 * @generated from field: ai.h2o.mlops.monitoring.v2.MonitoringOptions monitoring_options = 19;
 */
monitoringOptions?: MonitoringOptions;
}
 & (
{ 
/**
 * Routes all traffic to a single endpoint.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.SingleDeployment single = 8;
 */
single?: SingleDeployment;
 }
 | 
{ 
/**
 * Duplicates traffic to a secondary deployment for testing without affecting users.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.ShadowDeployment shadow = 9;
 */
shadow?: ShadowDeployment;
 }
 | 
{ 
/**
 * Distributes traffic across multiple variants based on configured rules.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.SplitDeployment split = 10;
 */
split?: SplitDeployment;
 }
)
;
export const deploymentName = getNameParser<'workspace' | 'deployment'>("workspaces/{workspace}/deployments/{deployment}");
/**
 * SingleDeployment routes all traffic to a single endpoint or service instance.
 * Use this for simple deployments where testing is not required.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.SingleDeployment
 */
export type SingleDeployment = {
/**
 * Represents the composition of a deployment, specifying key attributes required for deploying a model.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.DeploymentComposition deployment_composition = 1;
 */
deploymentComposition: DeploymentComposition;
/**
 * Optional resource specifications to pass directly to Kubernetes.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesResourceSpec kubernetes_resource_spec = 2;
 */
kubernetesResourceSpec?: KubernetesResourceSpec;
/**
 * Optional Kubernetes configuration shortcut options to apply.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesConfigShortcut kubernetes_config_shortcut = 3;
 */
kubernetesConfigShortcut?: KubernetesConfigShortcut;
/**
 * Optional. Runtime environment variables to pass to the deployment.
 * If predefined environment variables are used, they will not be overwritten.
 *
 * @generated from field: map<string, string> runtime_environment_variables = 4;
 */
runtimeEnvironmentVariables?: { [key: string]: string };
/**
 * VerticalPodAutoscaler configuration for the deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.VpaResourceSpec vpa_spec = 5;
 */
vpaSpec?: VpaResourceSpec;
/**
 * PDB configuration for the deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.PodDisruptionBudgetSpec pod_disruption_budget = 6;
 */
podDisruptionBudget?: PodDisruptionBudgetSpec;
}
;
/**
 * Represents a deployment strategy where traffic is duplicated across two elements.
 * The primary element processes all incoming requests and returns responses to users,
 * while the secondary element receives identical copies of all requests but its
 * responses are discarded and never returned to users.
 *
 * This deployment type enables risk-free testing of new versions, monitoring performance
 * differences, or validating behavior of experimental implementations without affecting
 * the user experience. Commonly used in Champion/Challenger scenarios or for
 * pre-production validation of new service versions.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ShadowDeployment
 */
export type ShadowDeployment = {
/**
 * The primary element that handles all user-facing traffic and returns responses.
 * This is typically the current production version or the "champion" in A/B testing.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.ShadowElement primary_element = 1;
 */
primaryElement: ShadowElement;
/**
 * The secondary element that receives copies of all requests but whose responses
 * are discarded. This allows for measuring performance, validating behavior, or
 * testing experimental changes without user impact.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.ShadowElement secondary_element = 2;
 */
secondaryElement: ShadowElement;
}
;
/**
 * Represents a shadow deployment element used in Champion/Challenger scenarios.
 *
 * In this setup, a primary model or service (Champion) handles requests, while one or more
 * alternative models or services (Challengers) receive the same requests without impacting
 * the primary response. This allows performance evaluation of new models before fully deploying them.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ShadowElement
 */
export type ShadowElement = {
/**
 * Represents the composition of a deployment, specifying key attributes required for deploying a model.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.DeploymentComposition deployment_composition = 1;
 */
deploymentComposition: DeploymentComposition;
/**
 * Optional resource specifications to pass directly to Kubernetes.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesResourceSpec kubernetes_resource_spec = 2;
 */
kubernetesResourceSpec?: KubernetesResourceSpec;
/**
 * Optional Kubernetes configuration shortcut options to apply.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesConfigShortcut kubernetes_config_shortcut = 3;
 */
kubernetesConfigShortcut?: KubernetesConfigShortcut;
/**
 * Optional. Runtime environment variables to pass to the deployment.
 * If predefined environment variables are used, they will not be overwritten.
 *
 * @generated from field: map<string, string> runtime_environment_variables = 4;
 */
runtimeEnvironmentVariables?: { [key: string]: string };
/**
 * VerticalPodAutoscaler configuration for the deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.VpaResourceSpec vpa_spec = 5;
 */
vpaSpec?: VpaResourceSpec;
/**
 * PDB configuration for the deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.PodDisruptionBudgetSpec pod_disruption_budget = 6;
 */
podDisruptionBudget?: PodDisruptionBudgetSpec;
}
;
/**
 * Represents a deployment that distributes incoming request traffic among multiple elements.
 *
 * This deployment type is useful for scenarios such as A/B testing, where different versions
 * of a model or service receive a portion of the requests for comparison and evaluation.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.SplitDeployment
 */
export type SplitDeployment = {
/**
 * A list of elements participating in the split deployment.
 * Each element defines its share of the request traffic.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.SplitElement split_elements = 1;
 */
splitElements: SplitElement[];
}
;
/**
 * Elements receive a percentage of the request traffic consistent with their relative `weight`.
 * For example, if there are three elements with weights 5, 10 and 35, the elements receives
 * 10%, 20% and 70% of the traffic, respectively.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.SplitElement
 */
export type SplitElement = {
/**
 * Represents the composition of a deployment, specifying key attributes required for deploying a model.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.DeploymentComposition deployment_composition = 1;
 */
deploymentComposition: DeploymentComposition;
/**
 * The weight of this deployment element compared to other deployment elements.
 * This value determines the fraction of traffic routed to this element.
 * For example, if two elements have weights of 2 and 8, traffic is split 20% and 80%.
 *
 * @generated from field: int32 weight = 2;
 */
weight: number;
/**
 * Optional resource specifications to pass directly to Kubernetes.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesResourceSpec kubernetes_resource_spec = 3;
 */
kubernetesResourceSpec?: KubernetesResourceSpec;
/**
 * Optional Kubernetes configuration shortcut options to apply.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesConfigShortcut kubernetes_config_shortcut = 4;
 */
kubernetesConfigShortcut?: KubernetesConfigShortcut;
/**
 * Optional. Runtime environment variables to pass to the deployment.
 * If predefined environment variables are used, they will not be overwritten.
 *
 * @generated from field: map<string, string> runtime_environment_variables = 7;
 */
runtimeEnvironmentVariables?: { [key: string]: string };
/**
 * VerticalPodAutoscaler configuration for the deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.VpaResourceSpec vpa_spec = 8;
 */
vpaSpec?: VpaResourceSpec;
/**
 * PDB configuration for the deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.PodDisruptionBudgetSpec pod_disruption_budget = 9;
 */
podDisruptionBudget?: PodDisruptionBudgetSpec;
/**
 * The effective percentage of traffic routed to this deployment element.
 * This value is derived from the weight relative to the sum of all weights.
 * This field is output only and cannot be set by the user.
 *
 * @generated from field: double effective_percentage = 10;
 */
effectivePercentage?: number;
}
;
/**
 * Cors represents the user specified CORS configuration for a deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.Cors
 */
export type Cors = {
/**
 * List of origins that are permitted to access the resource (i.e., deployment)
 * If global env var `ENVIRONMENT_KUBERNETES_COR_ORIGIN` is also set, URLs set in this API will be *appended* to the list
 * If too many values are passed in `origins`, the backend will reject the request
 * `origins` should be absolute URLs, and not wildcards. e.g., ["https://mlops.cloud.h2o.ai", "https://app.customer.ai"]
 *
 * @generated from field: repeated string origins = 1;
 */
origins: string[];
}
;
